import { useGetMe } from "@shared/services/get-me";
import { ROLE_TYPES } from "../types/role";
import { ValueOf } from "../types/utilities";

export const useUserTypeCheck = (userType: ValueOf<typeof ROLE_TYPES>) => {
  const { data: member } = useGetMe();
  return member?.role?.type === userType;
};
